import { render } from "./ProfessionalHistory.vue?vue&type=template&id=20e42148&scoped=true"
import script from "./ProfessionalHistory.vue?vue&type=script&lang=js"
export * from "./ProfessionalHistory.vue?vue&type=script&lang=js"

import "./ProfessionalHistory.vue?vue&type=style&index=0&id=20e42148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e42148"]])

export default __exports__